import React from 'react';
import PortfolioCarousel from './PortfolioCarousel';
import ApplicationSorter from '../Applications/ApplicationSorter';
import Event from '../Event';
import moment from 'moment';
import { Tooltip } from 'reactstrap';
import Url from '../Url';

export default class ProfileDetailedCard extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			tooltip: {
				singleMessage: false,
				notes: false,
				shortlist: false,
				singleShare: false,
				connectUser: false
			}
		};
	}

	coverLetter(e) {
		e.preventDefault();
		Event.fire("contentModal.show", {
			title: "Cover Letter",
			content: this.props.user.formattedCoverLetter
				? this.props.user.formattedCoverLetter
				: this.props.user.coverletter,
			type: this.props.user.formattedCoverLetter ? "html" : "text"
		});
	}

	fireModalEvent(e, modalName) {
		e.preventDefault();
		Event.fire(`${modalName}.show`, this.props.user);
	}

	answersList(answers) {
		let answer = "";
		for (let key in answers) {
			if (answers.hasOwnProperty(key) && answers[key].txt) {
				if (answer === "") {
					answer = answers[key].txt;
				} else {
					answer += `, ${answers[key].txt}`;
				}
			}
		}
		return answer;
	}

	agent(agent, index) {
		return (
			<div key={index}>
				<p className="small mb-0">Agent:</p>
				<p className="small mb-0">
					{agent.agent_uid && agent.company ? (
						<a href={Url.getProfileUrl(agent)} target="_blank">
							<strong>{agent.company}</strong>
						</a>
					) : (
							<strong>{agent.company ? agent.company : agent.name}</strong>
						)}
				</p>
				{agent.tel || agent.user_tel ? (
					<p className="small mb-0">{agent.tel ? agent.tel : agent.user_tel}</p>
				) : null}
			</div>
		);
	}

	tooltipToggle(name) {
		let tooltip = this.state.tooltip;
		tooltip[name] = !this.state.tooltip[name];
		this.setState({ tooltip });
	}

	note(e) {
		e.preventDefault();
		let content = this.props.user.note + (this.props.user.note_updated_at ? " - " + moment(this.props.user.note_updated_at).format("Do, MMMM  YYYY HH:mm") : null);

		Event.fire("contentModal.show", {
			title: "Note",
			content
		});
	}

	// TODO: Move to a separate file to prevent code duplication.
	tooltips(suffix) {
		let modalTooltips = [
			{
				show: true,
				id: "singleMessage",
				event: "singleMessageModal",
				icon: "far fa-envelope-open",
				activeClass: "",
				tooltipText: "Message"
			},
			{
				show: [2, 3].indexOf(window.loggedInUser.type) > -1,
				id: "notes",
				event: "notesModal",
				icon: "fa fa-pencil-square-o",
				activeClass: this.props.user.note ? "active" : "",
				tooltipText: "Notes"
			},
			{
				show: [2, 3].indexOf(window.loggedInUser.type) > -1,
				id: "shortlists",
				event: "shortlistModal",
				icon: "far fa-star",
				activeClass: this.props.shortlisted ? "active" : "",
				tooltipText: "Shortlists"
			},
			{
				show: true,
				id: "singleShare",
				event: "singleShareModal",
				icon: "far fa-share-alt",
				activeClass: "",
				tooltipText: "Share"
			},
			{
				show: window.loggedInUser.type === 1 && this.props.user.type === 1 && window.userConnections.indexOf(this.props.user.access_uid) === -1,
				id: "connectUser",
				event: "connectUserModal",
				icon: "fa fa-user-plus",
				activeClass: "",
				tooltipText: "Connect to user"
			},
		];

		return (
			<div>
				{modalTooltips.map((tooltip) => {
					let id = `${tooltip.id}_tooltip_${this.props.user.uid}_${suffix}`;
					let onClick = !tooltip.event && tooltip.onClick ? tooltip.onClick : e => this.fireModalEvent(e, tooltip.event);
					return tooltip.show ? (
						<a key={id} id={id} href="#" onClick={onClick} className={tooltip.activeClass}>
							<i className={tooltip.icon} aria-hidden="true" />
						</a>
					) : null;
				})}
				{modalTooltips.map((tooltip) => {
					let id = `${tooltip.id}_tooltip_${this.props.user.uid}_${suffix}`;
					return tooltip.show ? (
						<Tooltip key={`${tooltip.id}_tooltip`} placement="bottom" isOpen={this.state.tooltip[tooltip.id]} target={id} toggle={() => this.tooltipToggle(tooltip.id)}>
							{tooltip.tooltipText}
						</Tooltip>
					) : null;
				})}
			</div>
		);
	}

	render() {
		return (
			<div className="card card-detailed mb-4 detailedCardContainer logCard" data-user-uid-log={this.props.user.uid}>
				<div className="row">
					<div className="col pb-40">
						<div className="row">
							<div className="col-4 pr-0 d-flex justify-content-center">
								<a href={this.props.user.candidateLink} target="_blank" className="no-print">
									<button type="button" className="btn btn-secondary btn-sm quick-view">
										View Profile
                  					</button>
								</a>
								<div className="card-img-container">
									<a href={this.props.user.candidateLink}>
										<img className="card-img-top img-fluid" loading="lazy" style={{ width: "100%" }} src={this.props.imageUrl} alt={`${this.props.user.firstname} ${this.props.user.lastname}`} />
										{this.props.user.agentapplication ? (
											<p className="text-center small secondary mt-1 mb-0">
												SUBMITTED BY AGENT
											</p>
										) : null}
									</a>
								</div>
							</div>
							<div className="col-8">
								<div className="card-body pt-0">
									<h5 className="card-title">
										<a href={this.props.user.candidateLink}>{`${this.props.user.firstname} ${this.props.user.lastname}`}</a>
									</h5>
									{this.props.user.primaryjobtxt && this.props.user.primaryjobtxt !== "" && this.props.user.primaryjoburl ? (
										<p className="secondary small sex-loc">
											<a className="no-color" href={this.props.user.primaryjoburl}>
												{this.props.user.primaryjobtxt}
											</a>
										</p>
									) : null}
									{this.props.user.sex !== undefined || this.props.user.state ? (
										<p className="secondary small sex-loc">
											{this.props.user.sex !== undefined && [0,1].indexOf(this.props.user.sex) > -1
												? this.props.user.sex
													? "Male /"
													: "Female /"
												: ""}{" "}
											{this.props.user.state}
										</p>
									) : null}
									<div className="usr-actions no-print">
										{window.loggedInUser ? this.tooltips("ProfileDetailedCard") : null}
									</div>
									{(this.props.user.agefrom && this.props.user.ageto) ||
										this.props.user.age ? (
											<p className="small mb-0">
												{this.props.user.agefrom && this.props.user.ageto ? `Age Range: ${this.props.user.agefrom} - ${this.props.user.ageto}` : `Visual Age: ${this.props.user.age}`}
											</p>
										) : null}
									{this.props.user.weightText ? (
										<p className="small mb-0">
											Weight: {this.props.user.weightText}
										</p>
									) : null}
									{this.props.user.heightText ? (
										<p className="small">
											Height: {this.props.user.heightText}
										</p>
									) : null}

									<p className="small mb-0">
										<strong>
											{this.props.user.tel && this.props.user.vis_tel ? this.props.user.tel : ""}
											{this.props.user.mobile && this.props.user.vis_mobile ? ` | ${this.props.user.mobile}` : ""}
										</strong>
									</p>
									{this.props.user.agents && this.props.user.agents.length > 0 ? this.props.user.agents.map((agent, index) => this.agent(agent, index)) : null}
								</div>
							</div>
						</div>
						<div className="row mt-3">
							<div className="col-md-12">
								{this.props.user.coverletter ? (
									<div>
										<p className="secondary intro">
											{this.props.user.coverletter.substr(0, 200)}
											{this.props.user.coverletter.length > 200 ? (
												<a href="#" onClick={e => this.coverLetter(e)}>
													... read more
												</a>
											) : null}
										</p>
									</div>
								) : (
										<div>
											{this.props.user.preparedListAnswers.slice(0, 5).map((item, index) => {
												return (
													<p key={index}>
														<strong>{item.list_txt}</strong>:{" "}
														{this.answersList(item.answers)}
													</p>
												);
											})}
										</div>
									)}

								{this.props.user.note ? (
									<div className="note">
										<p className="mb-0">
											<a href="#" onClick={e => this.fireModalEvent(e, "notesModal")}>
												<i className="fa fa-pencil" aria-hidden="true" />
											</a>{" "}
											{this.props.user.note.substr(0, 150)}
											{this.props.user.note.length > 150 ? (
												<a href="#" onClick={e => this.note(e)}>
													... read more
												</a>
											) : null}
											<br />
											{this.props.user.note_updated_at ? " - " + moment(this.props.user.note_updated_at).format("Do, MMMM  YYYY HH:mm") : null}
										</p>
									</div>
								) : null}
							</div>
						</div>
						<ApplicationSorter key={`${this.props.user.uid}_${this.props.user.application_uid}`} className="no-print" user={this.props.user} />
					</div>
					<div className="col">
						<PortfolioCarousel
							idPrefix="detailedCard_"
							user={this.props.user}
							getImageUrl={(uid, directory, ext) => this.props.getImageUrl(uid, directory, ext)}
							contentType={this.props.contentType ? this.props.contentType : null}
						/>
					</div>
				</div>
			</div>
		);
	}
}
